module.exports = __webpack_public_path__ + "static/HKGrotesk-BoldItalic-85d68e94d8d7bf70ec809a680c6c1299.woff2";